
import { Box, Flex, Text } from '@chakra-ui/react';

interface SkillsSectionProps {
  skills?: string[];
}

export function SkillsSection({ skills }: SkillsSectionProps) {
  return (
    <Box px="20px" mb="20px">
      <Text as="h2" fontSize="20px" fontWeight="bold" color="#1e293b" mb="16px" letterSpacing="wide" mt="0">Skills</Text>
      <Box bg="white" borderRadius="20px" p="20px" boxShadow="0 6px 20px rgba(100,116,139,0.1)" border="1px solid" borderColor="#f1f5f9">
        <Flex flexWrap="wrap" gap="12px">
          {skills && skills.length > 0 ? (
            skills.map((skill: string) => (
              <Box key={skill} bg="#edf2f7" px="16px" py="10px" borderRadius="24px" border="1px solid" borderColor="#e2e8f0" boxShadow="0 2px 4px rgba(100,116,139,0.05)">
                <Text as="span" fontSize="14px" fontWeight="semibold" color="#374151" letterSpacing="wide">{skill}</Text>
              </Box>
            ))
          ) : (
            <Text as="span" fontSize="14px" fontWeight="semibold" color="#374151" letterSpacing="wide">No skills added yet.</Text>
          )}
        </Flex>
      </Box>
    </Box>
  );
}
